import styled from 'styled-components';

export const ContainerTemplates = styled.div`
  padding: var(--spacing-3xl) var(--spacing-xl);
  min-height: calc(100vh - 200px);
  background-color: var(--bg-main);
  margin: 0;

  .page-header {
    margin-bottom: var(--spacing-3xl);
    
    h2 {
      color: var(--primary-color);
      font-weight: var(--font-weight-semibold);
      margin-bottom: var(--spacing-sm);
    }
    
    p {
      font-size: var(--font-size-lg);
      margin-bottom: 0;
      color: var(--text-secondary);
    }
  }

  .card {
    border: none;
    border-radius: var(--border-radius-lg);
    box-shadow: var(--shadow-md);
    
    .card-header {
      background: var(--primary-color);
      color: var(--text-light);
      border-radius: var(--border-radius-lg) var(--border-radius-lg) 0 0 !important;
      border: none;
      
      h5 {
        font-weight: var(--font-weight-semibold);
        color: var(--text-light);
      }
    }
    
    .card-body {
      padding: var(--spacing-2xl);
      background: var(--bg-light);
    }
  }

  .form-label {
    font-weight: var(--font-weight-semibold);
    color: var(--primary-color);
    margin-bottom: var(--spacing-sm);
  }

  .form-control {
    border-radius: var(--border-radius-md);
    border: 2px solid var(--gray-200);
    padding: var(--spacing-md) var(--spacing-lg);
    font-size: var(--font-size-sm);
    transition: all 0.3s ease;
    
    &:focus {
      border-color: var(--primary-color);
      box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);
    }
  }

  .table {
    margin-bottom: 0;
    
    th {
      background-color: var(--gray-100);
      border-top: none;
      color: var(--primary-color);
      font-weight: var(--font-weight-semibold);
      padding: var(--spacing-lg);
    }
    
    td {
      padding: var(--spacing-lg);
      vertical-align: middle;
      color: var(--text-muted);
      
      code {
        background-color: var(--gray-100);
        color: var(--primary-color);
        padding: var(--spacing-xs) var(--spacing-sm);
        border-radius: var(--border-radius-sm);
        font-size: var(--font-size-xs);
      }
    }
    
    tbody tr:hover {
      background-color: var(--gray-100);
    }
  }

  .badge {
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    padding: var(--spacing-xs) var(--spacing-md);
    
    &.bg-success {
      background-color: var(--primary-color) !important;
    }
    
    &.bg-warning {
      background-color: var(--accent-color) !important;
      color: var(--text-light);
    }
    
    &.bg-info {
      background-color: var(--secondary-color) !important;
    }
  }

  .btn {
    border-radius: var(--border-radius-md);
    font-weight: var(--font-weight-medium);
    padding: var(--spacing-sm) var(--spacing-xl);
    transition: all 0.3s ease;
    
    &.btn-outline-primary {
      border-color: var(--primary-color);
      color: var(--primary-color);
      
      &:hover {
        background-color: var(--primary-color);
        border-color: var(--primary-color);
      }
    }
  }

  .spinner-border {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const ConfigSection = styled.div`
  .card {
    background: var(--bg-light);
    
    .card-header {
      background: var(--secondary-color);
      color: var(--text-light);
    }
  }
`;

export const TemplateCard = styled.div`
  background: var(--bg-light);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-xl);
  margin-bottom: var(--spacing-lg);
  box-shadow: var(--shadow-sm);
  border: 2px solid transparent;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: var(--primary-color);
    box-shadow: var(--shadow-lg);
  }
  
  .template-name {
    color: var(--primary-color);
    font-weight: var(--font-weight-semibold);
    margin-bottom: var(--spacing-sm);
  }
  
  .template-id {
    background-color: var(--gray-100);
    color: var(--primary-color);
    padding: var(--spacing-xs) var(--spacing-sm);
    border-radius: var(--border-radius-sm);
    font-family: 'Courier New', monospace;
    font-size: var(--font-size-xs);
    display: inline-block;
    margin-bottom: var(--spacing-sm);
  }
  
  .template-variables {
    color: var(--text-secondary);
    font-size: var(--font-size-xs);
    line-height: 1.4;
  }
`;
